import React from "react";
import Brick from './Brick';
import { Field } from 'redux-form';
import { Col, FormGroup, Label } from 'reactstrap';

/** Class representing a workflow brick to
 * initialize some context data.
 *
 * [server_side]
 */
class ContextSetData extends Brick {
    /**
     * Get this brick options form
     *
     * @param {Object} props: an object with the following keys
     *                          - t
     *                          - workflow
     *                          - forms
     *                          - emails
     *                          - articles
     *                          - salepoints
     */
    getOptionsForm(props) {
        const { workflow } = props;

        if (!workflow?.bricks?.length || this.position >= workflow.bricks.length - 1)
            return null;

        const options = {};
        workflow.bricks.forEach(brick => {
            if (brick.position <= this.position)
                return;

            brick.inputs.forEach(input => {
                options[input] = true;
            });
        });
        if (!Object.keys(options).length)
            return null;

        return (
            <>
                {Object.keys(options)?.map((option, index) => (
                    <FormGroup key={index} row>
                        <Label for={option} className="text-v-center" sm={4}>
                            { option }
                        </Label>
                        <Col sm={8}>
                            <Field component="input" type="text" name={`bricks[${this.position}].options.${option}`} className="form-control" />
                        </Col>
                    </FormGroup>
                ))}
            </>
        );
    }
}

export default ContextSetData;
